import React from 'react';
import PropTypes from 'prop-types';
import styles from './Layout.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { updateUniState } from '../../../Redux/universalMenu/uniSlice';
import UniMenuLogo from 'assets/icons/UniMenuLogo';

function TemplatesContainer ({ children }) {
  const dispatch = useDispatch();
  const { view, expandState } = useSelector((state) => state.uniMenuState);

  const isTouchScreen = () => 'ontouchstart' in document.documentElement;

  const openMenu = () => {
    dispatch(updateUniState(true));
  };

  const easyCloseMenu = () => {
    if (window.innerWidth < 500 && isTouchScreen() && view) {
      dispatch(updateUniState(false));
    }
  };

  return (
    <div
      className={`${styles.content} ${styles.closedMenu} ${view && styles[expandState]}`}
      onClick={easyCloseMenu}
    >
      {!view && (
        <button className="menu_logo_btn" onClick={openMenu}>
          <UniMenuLogo />
        </button>
      )}
      {children}
    </div>
  );
}

TemplatesContainer.propTypes = {
  children: PropTypes.any.isRequired
};

export default TemplatesContainer;
